import './App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Home from './pages/Home/Home';
import 'bootstrap/dist/css/bootstrap.min.css';
import Scroll from './components/Scroll/Scroll';
import React, { useEffect } from 'react';
import Proyectos from './pages/Proyectos/Proyectos';


function App() {
  useEffect(() => {

    const scrollToTop = () => {
      window.scrollTo(0, 0);
    };

    scrollToTop();
  }, []);

  return (
    <BrowserRouter>

      <Scroll />

      <Routes>
        <Route path="/" element={<Home />} />



      </Routes>

    </BrowserRouter>
  );
}

export default App;
